<template>
  <div>
    <SmallSquare content="1、接收人用于接收消息订阅中推送的手机短信和数据助手通过公众号推送的相关信息（需设置方可）。
2、最多可以设置20位接收人，接收人通过手机短信接收到已订阅的信息，需确保手机设置正确
3、可设置接收人接收手机短信或者数据助手消息这两种接收方式中一种或者两种；当需要接收数据助手消息时，必须在添加接收人时选择绑定数据助手的微信昵称(获取昵称需先绑定个人微信)" />
    <div class='mb25 m-t-25  s_flex_ali'>
      <span class='mr15'>
        <a-button type="primary" @click="receiverVisible=true">
          <PlusOutlined />
          添加接收人
        </a-button>
      </span>
    </div>
    <a-table :pagination='false' :loading='listLoading' bordered rowKey='name' :columns='columns' :data-source='data'>
      <template v-slot:action="{ record }">
        <a-dropdown>
          <a class="ant-dropdown-link"> 操作
            <DownOutlined />
          </a>
          <template v-slot:overlay>
            <a-menu>
              <a-menu-item>
                <a @click="detail(record)" href="javascript:;">修改</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="del(record.id)" href="javascript:;">删除</a>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </template>
    </a-table>
    <!--  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" /> -->
  </div>
  <a-modal  :keyboard="false" title="添加接收人" centered v-model:visible="receiverVisible" :confirm-loading="confirmLoading" @ok="handleSubmit" @cancel="receiver={}" destroyOnClose>
    <a-form ref="receiverForm" :model="receiver" :rules="receiver" :label-col="{span:6}" :wrapper-col="{span:14}">
      <a-form-item ref="name" label="接收人名称" name="name" :rules="[{ required: true, message: '请输入接收人名称' }]">
        <a-input v-model:value="receiver.name" />
      </a-form-item>
      <a-form-item ref="phone" label="接收人手机号" name="phone" :rules="[{ required: true, message: '请输入接收人手机号' }]">
        <a-input v-model:value="receiver.phone" />
      </a-form-item>
      <a-form-item ref="id" label="id" name="id" hidden>
        <a-input v-model:value="receiver.id" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import { inject, reactive, ref, toRefs } from "vue";
import { DownOutlined } from "@ant-design/icons-vue";
import {
  getreceiver,
  createReceiver,
  delReceiver,
  receiverDetail,
  editReceiver,
} from "@/api/message.js";
import { iscode } from "@/utils/app";
import { message } from "ant-design-vue";
// 初始化默认筛选项数值
let defSearch = {
  page: 1,
  limit: 10,
};
export default {
  components: {
    DownOutlined,
  },
  setup() {
    let columns = [
      {
        title: "接收人",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "手机号码",
        dataIndex: "phone",
        key: "phone",
      },
      {
        title: "创建时间",
        dataIndex: "create_time",
        key: "create_time",
      },
      {
        title: "操作",
        key: "action",
        slots: { customRender: "action" },
      },
    ];
    const state = reactive({
      receiverVisible: false,
      confirmLoading: false,
    });
    // 新增接收人表单
    let receiver = ref({ name: "", phone: "" });
    let receiverForm = ref();
    const handleSubmit = () => {
      receiverForm.value.validate().then(async (e) => {
        state.confirmLoading = true;
        let result = await createReceiver(e)
          .then((res) => res.data)
          .catch((error) => error);
        state.confirmLoading = false;
        if (iscode(result, true)) {
          receiverForm.value.resetFields();
          state.receiverVisible = false;
          initData(search.value);
        }
      });
    };
    const $Modal = inject("$Modal");
    // 删除接收人
    const del = (id) => {
      $Modal.confirm({
        centered: true,
        content: "删除后该接收人将无法恢复，您确定要删除该接收人吗？",
        onOk: async () => {
          let res = await delReceiver(id).then((res) => res.data);
          if (iscode(res)) {
            message.success(res.msg);
            initData(search.value);
          } else {
            message.error(res.msg);
          }
        },
      });
    };
    const detail = (data) => {
        receiver.value=data
          state.receiverVisible = true;
    };
    // // 初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    let listLoading = ref(false);
    let data = ref([]);
    let total = ref(0);
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    const initData = async (values) => {
      listLoading.value = true;
      let res = await getreceiver(values).then((res) => res);
      listLoading.value = false;
      data.value = res.data.data;
    };
    initData(search.value);
    return {
      columns,
      listLoading,
      pageSizeChange,
      pageCurrentChange,
      search,
      data,
      total,
      ...toRefs(state),
      handleSubmit,
      receiver,
      receiverForm,
      del,
      detail,
    };
  },
};
</script>